var map = {
	"./MetaMaskConnected.svg": "41da",
	"./arrow-white.svg": "0e6c",
	"./arrow.svg": "21e2",
	"./arrow2.svg": "7c5e",
	"./busd.svg": "4ac4",
	"./cashback.svg": "aac7",
	"./circle.svg": "b289",
	"./circle_check.svg": "a7d1",
	"./circle_check_black.svg": "76a7",
	"./circle_check_black_unchecked.svg": "94b6",
	"./circle_check_unchecked.svg": "6512",
	"./close.svg": "8b1b",
	"./coins-icons-v2-bsc-pool1.svg": "0050",
	"./connected.svg": "a4b2",
	"./copy.svg": "8aac",
	"./dai.svg": "3989",
	"./deposit.svg": "dec4",
	"./diamond.svg": "3daa",
	"./dollar.svg": "ae9c",
	"./empty.svg": "8b70",
	"./error.svg": "28c3",
	"./estimate.svg": "9360",
	"./gold.svg": "9169",
	"./info2.svg": "e66e",
	"./info_circle_outline.svg": "a9c5",
	"./info_circle_outline_black.svg": "bc58",
	"./link.svg": "40a1",
	"./liquid-circle-light.svg": "0881",
	"./liquid-circle-white.svg": "4968",
	"./liquid-circle.svg": "1675",
	"./loading-val-white.svg": "e7a8",
	"./loading-val.svg": "f649",
	"./metamask.svg": "a9b9",
	"./more.svg": "0f4c",
	"./not-empty.svg": "ed87",
	"./plus.svg": "eb38",
	"./refresh.svg": "53fa",
	"./sig.svg": "6048",
	"./tbusd.svg": "a876",
	"./tdai.svg": "c37d",
	"./time.svg": "79aa",
	"./tusdc.svg": "5011",
	"./tusdt.svg": "78bc",
	"./union.svg": "f46c",
	"./usdc.svg": "2cd8",
	"./usdc2OLD.svg": "42cc",
	"./usdt.svg": "b1d1",
	"./usdtOLD2.svg": "a855",
	"./walletconnect.svg": "c57c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a244";